import React, {useEffect} from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
} from 'reactstrap';

import {useSelector, useDispatch} from "react-redux";

import {Link} from "react-router-dom";
import withRouter from "../common/withRouter";
import "cleave.js/dist/addons/cleave-phone.us"
import {recordActivity} from "../slices/register";

const ContactSuccess = (props) => {
    const dispatch = useDispatch();
    const {
        createContactResearchAssistantSuccess
    } = useSelector(state => ({
        createContactResearchAssistantSuccess: state.register.createContactResearchAssistantSuccess,
    }));


    useEffect(() => {
        let deviceId = sessionStorage.getItem('device') || undefined
        dispatch(recordActivity(deviceId, {
            action: "survey",
            page_id: "0-6"
        }))
    }, [dispatch, sessionStorage, recordActivity])

    document.title = "Success";
    return (
        <React.Fragment>
            <div>
                <Container>
                    <Row className="pt-5  justify-content-center">
                        <Col className="p-0" md={6} sm={12}>
                            <div className="text-center mt-2">
                                <h3>Guided Eligibility Survey</h3>
                            </div>
                            <Card className="mt-4">
                                <CardBody className="p-4">
                                    <div className="p-2 mt-4">
                                        {createContactResearchAssistantSuccess}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
        ;
};

export default withRouter(ContactSuccess);
